import React, { useState, useEffect } from "react";
import AddPetDetails from "../AddPetDetails";
import EditPetDetails from "../EditPetDetails";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { FaEdit } from "react-icons/fa";
import petimage from "../../assets/images/pet-details.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import config from "./../../config";

const Pet = () => {
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [pet_data, setPet_data] = useState([]);
  const [selectedPetId, setSelectedPetId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const token = localStorage.getItem("token");
  let id;

  if (!token) {
    window.location.href = "https://findlocalpetservices.com/";
  } else {
    const decoded = jwtDecode(token);
    id = decoded.data.customer_data.id;
  }

  const getData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${config.API_BASE_URL}/customer/getallpet`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setPet_data(response.data.pets);
      }
    } catch (error) {
      console.error("Error fetching pet data:", error.response?.data || error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleEdit = (id) => {
    openEditModal(id);
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const openEditModal = (id) => {
    setSelectedPetId(id);
    setIsEditModal(true);
  };

  const closeEditModal = () => {
    setSelectedPetId(null);
    setIsEditModal(false);
    getData();
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div className="p-4 bg-white rounded shadow-md md:block hidden">
      <div
        className="flex justify-between items-center font-bold text-xl pb-2 cursor-pointer"
        onClick={toggleFormVisibility}
      >
        <h2>My Pet</h2>
        {!isFormVisible ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {isFormVisible && (
        <>
          {pet_data.map((pet) => (
            <div
              key={pet._id}
              className="flex items-center mt-4 p-2 border rounded-lg bg-gray-50"
            >
              <img
                src={pet.pet_images[0] || petimage}
                alt={pet.name}
                className="w-12 h-12 rounded-full bg-gray-200"
              />
              <div className="ml-4">
                <p className="font-bold capitalize">{pet.name}</p>
                <p className="text-sm text-gray-600">
                  {pet.breed} • {pet.age} • {pet.gender}
                </p>
                <p className="text-xs text-gray-500">
                  Vaccinated: {pet.vaccinated || "N/A"} | Aggression:{" "}
                  {pet.aggression || "N/A"}
                </p>
              </div>
              <FaEdit
                className="text-xl cursor-pointer ml-auto text-orange-500"
                onClick={() => handleEdit(pet._id)}
              />
            </div>
          ))}

          {/* ✅ Always visible Add Pet button */}
          <div className="mt-6">
            <button
              className="w-[130px] h-[45px] p-2 text-[#FF6216] bg-white border-[#FF6216] border rounded font-bold hover:bg-orange-50"
              onClick={openModal}
            >
              + Add Pet
            </button>
          </div>
        </>
      )}

      {/* ✅ Add Pet Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl h-4/5 overflow-y-auto">
            <AddPetDetails onClose={closeModal} />
          </div>
        </div>
      )}

      {/* ✅ Edit Pet Modal */}
      {isEditModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl h-4/5 overflow-y-auto">
            <EditPetDetails petId={selectedPetId} onClose={closeEditModal} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Pet;
